module.exports = __webpack_public_path__ + "static/media/shopping-cart.fdf64f28.svg";